




import { Component, Vue } from 'vue-property-decorator'
import roleSettingCom from './roleSettingCom.vue'

@Component({
  name: '',
  components: {
    roleSettingCom
  }
})
export default class extends Vue {
  dataObj = {
    type: 'role',
    detailUrl: '/blackcat/role/detail',
    assignUrl: '/blackcat/role/permission/assign'
  }
}
